import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import DontLoseYourStreak from "./popups/ui-1/DontLoseYourStreak";
import OutOfTurns from "./popups/ui-1/OutOfTurns";
import StreakRestored from "./popups/ui-4/StreakRestored";
import { getStreakStatus, postLoginStreakRevive } from "../Redux/futures/shweJourney/actions";
import { curLoginStreakStatus } from "../Redux/selector";
import PATH from "../config/PATH";

// Popup cảnh báo mất chuỗi (POP-01 nghỉ 1 ngày / POP-02 nghỉ 2 ngày) — entry pu9
// của popup manager. Gói trọn luồng hồi sinh trước đây nằm ở Home/index.jsx:
//   DontLoseYourStreak → revive → StreakRestored
//   thiếu lượt / thiếu item → OutOfTurns mở chồng lên DontLoseYourStreak
// onClose chỉ được gọi khi cả luồng kết thúc, để engine không mở popup khác chen vào.
export default function PopupStreakWarning({ streak, onClose }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginStreakStatus } = useSelector(curLoginStreakStatus);

  const [checked, setChecked] = useState("TURN");
  const [isReviving, setIsReviving] = useState(false);
  const [openOutOfTurns, setOpenOutOfTurns] = useState(false);
  // Khác null = đã revive thành công, chuyển sang màn StreakRestored.
  const [dataClaim, setDataClaim] = useState(null);

  const revive = streak?.revive || {};
  const userTurnBalance = revive.user_turn_balance || 0;
  const userReviveItemBalance = revive.user_revive_item_balance || 0;
  const userCostTurn = revive.cost_turn || 0;
  const userCostReviveItem = revive.cost_revive_item || 0;

  const afterRevive = (res, isLoading, error) => {
    if (isLoading) return;
    setIsReviving(false);

    if (error) {
      toast.error(error?.errorMessage);
      return;
    }

    if (res) {
      setOpenOutOfTurns(false);
      setDataClaim(res?.data || {});
      dispatch(getStreakStatus({}));
    }
  };

  const handleRevive = () => {
    if (isReviving) return;

    if (checked === "TURN" && userTurnBalance < userCostTurn) {
      setOpenOutOfTurns(true);
      return;
    }
    if (checked === "REVIVE_ITEM" && userReviveItemBalance < userCostReviveItem) {
      setOpenOutOfTurns(true);
      return;
    }

    setIsReviving(true);
    dispatch(postLoginStreakRevive({ payment_method: checked, callback: afterRevive }));
  };

  if (dataClaim) {
    // Redux đã được getStreakStatus làm mới sau revive; chưa về kịp thì dùng
    // bản engine đã fetch lúc chọn popup.
    const latest = Array.isArray(loginStreakStatus) ? streak : loginStreakStatus;
    return (
      <StreakRestored
        open
        onOpenChange={(open) => !open && onClose()}
        data={latest}
        dataClaim={dataClaim}
        checked={checked}
        handleClick={() => {
          onClose();
          navigate(PATH.SHWE_JOURNEY);
        }}
        textBtn={t("shwe_journey.claim_todays_reward")}
      />
    );
  }

  return (
    <>
      <DontLoseYourStreak
        open
        onOpenChange={(open) => !open && onClose()}
        checked={checked}
        setChecked={setChecked}
        days={streak?.day_off}
        cost_revive_item={revive.cost_revive_item}
        cost_turn={revive.cost_turn}
        disabled={revive.cost_turn}
        userReviveItemBalance={userReviveItemBalance}
        userTurnBalance={userTurnBalance}
        handleClick={handleRevive}
      />
      <OutOfTurns
        open={openOutOfTurns}
        onOpenChange={setOpenOutOfTurns}
        hiddenText={false}
      />
    </>
  );
}
